module.exports = __webpack_public_path__ + "media/images/icon-history-1b7b939e1690b3dcb685dc9ec921bee1.svg";